import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { REQUEST_P360_PARTNER_FLAGS } from 'partner360/features/p360PartnerFlags/constants'
import { selectP360PartnerFlagsState } from 'partner360/features/p360PartnerFlags/selectors/selectP360PartnerFlagsState'
import { fetchP360PartnerFlags } from 'partner360/services/p360PartnerFlags/fetchP360PartnerFlags'

export const requestP360PartnerFlags = createAsyncThunk(
  REQUEST_P360_PARTNER_FLAGS,
  async () => {
    return await fetchP360PartnerFlags()
  },
  {
    condition: (_, { getState }) => {
      const state = compose(selectP360PartnerFlagsState, getState)()
      return !state.data.length
    },
  }
)
